<div class="sub-menu">
  @for (item of items; track item) {
    @if (hasAccess(item)) {
      <cm-menu-item [item]="item" class="sub-menu-level-2"></cm-menu-item>
    }
  }
</div>
